import { z } from 'zod/v4';

export const homemakerFormSchema = z.object({
  kind: z.literal('homemaker'),
});

type HomemakerFormValues = z.infer<typeof homemakerFormSchema>;

export const defaultHomemakerFormValues: HomemakerFormValues = {
  kind: 'homemaker',
};

// There is no need for a component for the homemaker form, because it has no additional fields
